import React, {useState} from "react";
import {useSite} from "../context/SiteContext";
import {APP_ANDROID, APP_IOS, SOCIALS} from "../data/siteData";
import {subscribeNewsletter} from "../services/CommonService";
import Utils, {asset, GRAD} from "../utils";
import Icon, {StoreGlyph} from "./common/Icon";
import {mailHref, telHref} from "./common/ContactText";
import Bars from "./common/Bars";

// Same email rule as the API (website-subscribe).
const isEmail = (value) => value.length <= 191 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);

const NewsletterForm = () => {
    const [email, setEmail] = useState('');
    const [website, setWebsite] = useState('');
    const [sending, setSending] = useState(false);
    const [result, setResult] = useState(null);

    const onSubmit = (e) => {
        e.preventDefault();
        const value = email.trim();
        if (!isEmail(value)) {
            setResult({ok: false, text: 'Please enter a valid email address.'});
            return;
        }
        setSending(true);
        setResult(null);
        subscribeNewsletter({email: value, website})
            .then(res => {
                setEmail('');
                setResult({ok: true, text: res.data.message});
            })
            .catch(err => setResult({ok: false, text: Utils.getErrorMessage(err)}))
            .finally(() => setSending(false));
    };

    const invalid = result && !result.ok;
    return (
        <form className="pb-newsletter" onSubmit={onSubmit} noValidate>
            <input type="email" name="email" placeholder="Your email" aria-label="Your email" autoComplete="email"
                   maxLength={191} value={email} aria-invalid={invalid || undefined}
                   aria-describedby={result ? 'newsletter-note' : undefined}
                   onChange={(e) => {
                       setEmail(e.target.value);
                       if (invalid) setResult(null);
                   }}/>
            {/* Honeypot: hidden from people, bots fill it in and the API then drops the sign-up. */}
            <input type="text" name="website" value={website} onChange={(e) => setWebsite(e.target.value)}
                   tabIndex={-1} autoComplete="off" aria-hidden="true" className="pb-honeypot"/>
            <button type="submit" className="hover-brighten" disabled={sending}>
                {sending ? 'Subscribing…' : 'Subscribe'}
            </button>
            {result && (
                <p id="newsletter-note" role="status"
                   className={result.ok ? 'pb-newsletter-note pb-newsletter-ok' : 'pb-newsletter-note pb-newsletter-error'}>
                    {result.text}
                </p>
            )}
        </form>
    );
};

const Footer = () => {
    const {go, settings} = useSite();
    const socials = SOCIALS.filter(s => settings[s.setting]);

    return (
        <footer className="pb-footer">
            <div className="pb-footer-grid">
                <div>
                    <img src={asset('assets/logo-white.png')} alt="Paddlers Box" style={{height: 38, display: 'block'}}/>
                    <p className="pb-footer-about">Self service canoe rental in Sweden and Denmark. Convenient,
                        flexible, sustainable.</p>
                    <div className="pb-footer-contact">
                        {settings.address && <p><Icon name="pin" size={16}/>{settings.address}</p>}
                        <a href={mailHref(settings.email)}><Icon name="mail" size={16}/>{settings.email}</a>
                        <a href={telHref(settings.phone_number)}><Icon name="phone" size={16}/>{settings.phone_number}</a>
                    </div>
                    <div style={{marginTop: 20}}><Bars w={20} h={4} gap={5}/></div>
                    {socials.length > 0 && (
                        <div className="pb-socials">
                            {socials.map(s => (
                                <a key={s.label} href={settings[s.setting]} aria-label={s.label} className="pb-social"
                                   target="_blank" rel="noopener noreferrer" style={{background: GRAD[s.color]}}>
                                    <Icon name={s.icon} size={18}/>
                                </a>
                            ))}
                        </div>
                    )}
                </div>
                <div>
                    <p className="pb-footer-title">Company</p>
                    <div className="pb-footer-links">
                        <button onClick={() => go('how')}>How it works</button>
                        <button onClick={() => go('price')}>Pricing</button>
                        <button onClick={() => go('loc')}>Locations</button>
                        <button onClick={() => go('contact')}>Host a box</button>
                    </div>
                </div>
                <div>
                    <p className="pb-footer-title">Support</p>
                    <div className="pb-footer-links">
                        <button onClick={() => go('safety')}>Safety</button>
                        <button onClick={() => go('contact')}>Help centre</button>
                        <a href="#terms">Terms of use</a>
                        <a href="#privacy">Privacy policy</a>
                    </div>
                </div>
                <div>
                    <p className="pb-footer-title">Get the app</p>
                    <div className="pb-footer-links">
                        <a href={APP_IOS} target="_blank" rel="noopener noreferrer" className="pb-footer-store">
                            <StoreGlyph kind="ios"/>App Store
                        </a>
                        <a href={APP_ANDROID} target="_blank" rel="noopener noreferrer" className="pb-footer-store">
                            <StoreGlyph kind="play"/>Google Play
                        </a>
                    </div>
                    <p className="pb-footer-title" style={{margin: '22px 0 8px'}}>Newsletter</p>
                    <NewsletterForm/>
                </div>
            </div>
            <div className="pb-footer-bottom">
                <p>© 2026 Paddlers Box</p>
            </div>
        </footer>
    );
};

export default Footer;
